"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _slugify = _interopRequireDefault(require("slugify"));

var _DatasetDownloadButton = _interopRequireDefault(require("./DatasetDownloadButton"));

var Dataset = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Dataset, _React$Component);

  function Dataset() {
    (0, _classCallCheck2.default)(this, Dataset);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Dataset).apply(this, arguments));
  }

  (0, _createClass2.default)(Dataset, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          content = _this$props2.content,
          format = _this$props2.format,
          name = _this$props2.name,
          onDownload = _this$props2.onDownload,
          size = _this$props2.size,
          src = _this$props2.src,
          title = _this$props2.title;
      return _react.default.createElement("section", {
        className: (0, _classnames.default)('margin-bottom-5', className),
        style: style
      }, _react.default.createElement("a", {
        name: (0, _slugify.default)(name.toLowerCase()),
        style: {
          display: 'block',
          position: 'relative',
          top: '-5em',
          visibility: 'hidden'
        }
      }), _react.default.createElement("h5", {
        className: "max-line-length"
      }, name), _react.default.createElement("div", {
        className: "flex-row flex-wrap"
      }, _react.default.createElement("div", {
        className: "margin-right-4 margin-bottom-4",
        style: {
          maxWidth: 300,
          minWidth: 160,
          width: '16vw'
        }
      }, _react.default.createElement(_DatasetDownloadButton.default, {
        className: "animated bounceIn",
        format: format,
        onDownload: onDownload,
        size: size,
        src: src,
        title: title
      })), content && content));
    }
  }]);
  return Dataset;
}(_react.default.Component);

Dataset.defaultProps = {
  content: null,
  format: null,
  name: 'Dataset',
  onDownload: null,
  size: null,
  src: null,
  title: 'Download dataset'
};
var _default = Dataset;
exports.default = _default;